// @ utilities
const apiURLBuilder = require('core/apiURLBuilder');
const {EMAILCONSTANTS} = require('constants/contactCenter/emailConstants');
const {
    APIPost,
    APIGet
} = require('utilities/APIRequestHelper');
const { formatText, hasTranslation } = require('core/i18n').i18n;

// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');
const { CONNECTION_CHANNEL_CONTACT_CENTER, SEND_ORDER, SAVE_DOCUMENTATION_NO } = require('constants/contactCenter/brokerFundsSendEmailConstants');

const resetPrecontractualMail = () => ({
    type: actionTypes.PRE_CONTRACTUAL_MAIL_RESET
});

const mailPreContractualToClientSuccess = () => ({
    type: actionTypes.PRE_CONTRACTUAL_MAIL_SENT_SUCCESS
});

const mailPreContractualToClientRequest = () => ({
    type: actionTypes.PRE_CONTRACTUAL_MAIL_SENT_REQUEST
});

const mailPreContractualToClientFailure = error => ({
    type: actionTypes.PRE_CONTRACTUAL_MAIL_SENT_FAILURE,
    payload: {
        error
    }
});

const getProductRequestData = (productName, templateCode, data) => {
    const requestData = {
        header: {
            version: 2
        },
        query: {
            productName,
            templateCode,
            data
        }
    };

    return requestData;
}

const getTypeSubtypeDataRequestData = (subType, type, standar, productName, templateCode, data = {}) => {
    const requestData = {
        query: {
            'estandarReferencia': standar,
            'producto': type,
            'subproducto': subType,
            productName,
            templateCode,
            data
        }
    };

    return requestData;
}

const sendPreContractualMail = ({ subType, type, standar, productName, data, ref = '', product = null }) => dispatch => {
    const productNameParsed = hasTranslation(`emailConstants-${type}${subType}${ref}`) ?
                            formatText(`emailConstants-${type}${subType}${ref}`) : (productName || EMAILCONSTANTS[`${type}${subType}${ref}`].productName)
    const templateCode = EMAILCONSTANTS[`${type}${subType}${ref}`].templateCode
    const requestData = !!product
        ?   getProductRequestData(productNameParsed, templateCode, data)
        :   getTypeSubtypeDataRequestData(subType, type, standar, productNameParsed, templateCode, data)

    dispatch(mailPreContractualToClientRequest());
    return APIPost(dispatch, apiURLBuilder.getURL(!!product ? 'mailPreContractualInfoProduct' : 'mailPreContractualInfo', { product }), requestData)
        .then(() => dispatch(mailPreContractualToClientSuccess()))
        .catch(error => dispatch(mailPreContractualToClientFailure(error))
    );
};

const sendBrokerPreContractualMail = params => dispatch => {
    dispatch(mailPreContractualToClientRequest());

    const requestData = {
        query: Object.assign({}, { channel: CONNECTION_CHANNEL_CONTACT_CENTER, sendOrder: SEND_ORDER, saveDocumentation: SAVE_DOCUMENTATION_NO }, params)
    };

    return APIPost(dispatch, apiURLBuilder.getURL('communication'), requestData)
        .then(() => dispatch(mailPreContractualToClientSuccess()))
        .catch(response => {
            if (response.error) {
                dispatch(mailPreContractualToClientFailure(response.error));
            } else {
                throw response;
            }
        });
};

const sendLoanPreContractualMail = params => (dispatch) => {

    const requestData = {
        query: params
    };

    dispatch(mailPreContractualToClientRequest());

    return APIPost(dispatch, apiURLBuilder.getURL('loansMail'), requestData)
        .then(() => dispatch(mailPreContractualToClientSuccess()))
        .catch(error => dispatch(mailPreContractualToClientFailure(error)));
};

const sendPackOpenYoungPreContractualMail = (params) => dispatch => {
    dispatch(mailPreContractualToClientRequest());

    const promises = Object.keys(params).map(key => {
        const {
            standar,
            subType,
            type,
        } = params[key];

        const requestData = {
            query: {
                'estandarReferencia': standar,
                'productName': EMAILCONSTANTS[`${type}${subType}`].productName,
                'producto': type,
                'subproducto': subType,
                'templateCode': EMAILCONSTANTS[`${type}${subType}`].templateCode,
            }
        };

        return APIPost(dispatch, apiURLBuilder.getURL('mailPreContractualInfo'), requestData)
    });

    return Promise.all(promises)
        .then(() => dispatch(mailPreContractualToClientSuccess()))
        .catch(error => dispatch(mailPreContractualToClientFailure(error)))
};

const sendRoboHirePrecontractualMail = () => (dispatch) => {
    dispatch(mailPreContractualToClientRequest());

    return APIGet(dispatch, apiURLBuilder.getURL('roboHireMail'), {})
        .then(() => dispatch(mailPreContractualToClientSuccess()))
        .catch(error => dispatch(mailPreContractualToClientFailure(error)));
};

const sendAmazonGiftCardPrecontractualMail = (productName) => (dispatch) => {
    const requestData = {
        query: productName
    }
    dispatch(mailPreContractualToClientRequest());

    return APIGet(dispatch, apiURLBuilder.getURL('amazonGiftCardPromotion'), requestData)
        .then(() => dispatch(mailPreContractualToClientSuccess()))
        .catch(error => dispatch(mailPreContractualToClientFailure(error)));
};

const sendPromotionPrecontractualMail = (params) => (dispatch) => {

    const requestData = {
        query: params
    };

    dispatch(mailPreContractualToClientRequest());

    return APIPost(dispatch, apiURLBuilder.getURL('promotionsPrecontractualMail'), requestData)
        .then(() => dispatch(mailPreContractualToClientSuccess()))
        .catch(error => {dispatch(mailPreContractualToClientFailure(error))})
}

module.exports = {
    resetPrecontractualMail,
    sendAmazonGiftCardPrecontractualMail,
    sendBrokerPreContractualMail,
    sendLoanPreContractualMail,
    sendPackOpenYoungPreContractualMail,
    sendPreContractualMail,
    sendPromotionPrecontractualMail,
    sendRoboHirePrecontractualMail,
};
